import { Injectable, inject } from '@angular/core';
import { Platform } from '@ionic/angular/standalone';
import { EncriptarService } from './encriptar.service';
import { getRemoteConfig, getValue, fetchAndActivate } from "firebase/remote-config";

@Injectable({
  providedIn: 'root'
})
export class FirebaseService {
  private encriptarService = inject(EncriptarService);
  platform = inject(Platform);

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);

  constructor() {

  }

  async conectarRemoteConfig() {
    const remoteConfig = getRemoteConfig();
    remoteConfig.settings = {
      fetchTimeoutMillis: 100000,
      minimumFetchIntervalMillis: 100000
    };

    await fetchAndActivate(remoteConfig)
      .then((remoteFetchAndActivate) => {
        //console.log('remoteFetchAndActivate: ', remoteFetchAndActivate);
        let tiempoExpiraLogin = getValue(remoteConfig, "tiempoExpiraLogin").asString()
        //console.log('tiempoExpiraLogin: ', tiempoExpiraLogin);
        this.encriptarService.guardarEnStorage('tiempoExpiraLogin', tiempoExpiraLogin)
        // let tiempoExpiraLogin = remoteConfig.getString('tiempoExpiraLogin').then(resRemote => {
        //   console.log('resRemote',resRemote);

        // })
        // console.log('tiempoExpiraLogin: ',tiempoExpiraLogin);

        // this.encriptarService.guardarEnStorage('tiempoExpiraLogin',this.remoteConfig.getString('tiempoExpiraLogin'))
        // if(this.platform.is('android') && !this.platform.is('pwa') && !this.platform.is('mobileweb')){
        //   //this.comprobarVersion(remoteConfig.getString('version_Android'))
        // }else if ((this.platform.is('ipad') || this.platform.is('ios') || this.platform.is('iphone')) && !this.platform.is('pwa') && !this.platform.is('mobileweb') ){
        //   //this.comprobarVersion(remoteConfig.getString('version_IOS'))
        // }else{
        //   if((this.platform.is('pwa')) || (this.platform.is('desktop'))){
        //     //this.comprobarVersionPWA('10')
        //     console.log('ES UNA PWA o WEB');
        //   }else{
        //     console.log('NO ES PWA. ',this.platform.platforms());

        //   }
        // }

        // return;



      })

}
}
